import React from 'react';
import { LinearProgress } from "@material-ui/core";

const ProgressBar = ({isProgress}) => {
    console.log("progress-bar-formik", isProgress);
    return (
        isProgress ?
            <div className="col-12">
                <LinearProgress color="primary" />
                <LinearProgress color="primary" />
            </div>
        :
        <></>
    );
};

export default ProgressBar;